/**
 * Server-enforced deadline for requesting Undo. Publication starts immediately;
 * a withdrawal requested before this deadline continues until it settles.
 */
export const UNDO_WINDOW_MS = 15 * 60_000;
